import React, { FC, useCallback } from 'react';
import { connect } from 'react-redux';
import { Redirect, Route, withRouter } from 'react-router';
import OverviewShell from '../overview_shell/OverviewShell';

const DataSet = require('@antv/data-set');

const DowntimeAnalyticsOverviewPage: FC<any> = ({
	history,
	userType,
	childRoutes,
}): React.ReactElement => {
	const handleTabChange = useCallback(
		(key) => history.push(`/${userType}/analytics/assets/overview/${key}`),
		[history, userType]
	);

	const checkTabActive = useCallback(
		(key) => {
			const pathname = history.location.pathname;
			return pathname.indexOf(key) !== -1;
		},
		[history.location.pathname]
	);

	const tabs = [
		{ key: 'current', name: 'Overview' },
		{ key: 'locations', name: 'Locations' },
		{ key: 'assetTypes', name: 'Asset Types' },
		{ key: 'manufacturers', name: 'Manufacturers' },
	];

	return (
		<>
			<Route
				path={`/${userType}/analytics/assets/overview`}
				exact={true}
				render={() => (
					<Redirect
						to={{
							pathname: `/${userType}/analytics/assets/overview/current`,
						}}
					/>
				)}
			/>
			<OverviewShell
				title="Downtime Analytics"
				tabs={tabs}
				onTabChange={handleTabChange}
				checkTabActive={checkTabActive}
				childRoutes={childRoutes}
				className="workAnalyticsPage"
			/>
		</>
	);
};

const mapStateToProps = (state, ownProps) => ({
	currentUser: state.session.currentUser,
});

const mapDispatchToProps = (dispatch) => ({});

const ComponentWithoutUserType = withRouter(
	connect(mapStateToProps, mapDispatchToProps)(DowntimeAnalyticsOverviewPage)
);

export default connect(
	(state) => ({
		userType: (state as any).session.userType,
	}),
	() => ({})
)(ComponentWithoutUserType);
